module.exports = __webpack_public_path__ + "img/img-4.add1fe37.webp";